// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ksxhqqztbiqvrdnsseaf.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtzeGhxcXp0YmlxdnJkbnNzZWFmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTYxNTM1ODUsImV4cCI6MjA3MTcyOTU4NX0.YjwW8Dt-U-szEXYfp4Fcm5Z9iK-ni1YshMIMF-nNsrI";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
  },
  global: {
    headers: {
      'x-client-info': 'moneyplus-wallet/1.0',
    },
    fetch: (url, options = {}) => {
      // Increase timeout for slow connections (Laos, etc.)
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 30000); // 30s timeout
      
      return fetch(url, {
        ...options,
        signal: controller.signal,
      }).finally(() => clearTimeout(timeoutId));
    },
  },
  db: {
    schema: 'public',
  },
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
    timeout: 30000,
    heartbeatIntervalMs: 45000,
  },
});